import { jwtDecode } from 'jwt-decode';

import { COOKIE_KEYS } from '../../utils/Constants';
import CookieServices from '../../services/CookieServices';

class Authenticator {
    Check(shadowID) {
        try {
            // Check for session cookies
            const accessKey = CookieServices.get(COOKIE_KEYS.TOKEN)
            const statusKey = CookieServices.get(COOKIE_KEYS.STATUS)

            if (!accessKey) {
                // Session cookies is not set
                return {
                    status: '',
                    identity: false,
                    statusExists: false,
                    resetSession: false,
                    authenticated: false,
                };
            }

            if (!shadowID.authenticated) {
                /* 
                 * Session cookie auto authenticates user
                 * 
                 * Perform Redux state check.
                 * If Redux state is not set, dispatch Identity
                 * to set user's identity
                 */

                return {
                    status: '',
                    identity: false,
                    statusExists: false,
                    resetSession: false,
                    authenticated: false,
                };
            }

            const decodedAccessKey = jwtDecode(accessKey);
            const identityMeta = decodedAccessKey.identity

            if (identityMeta.email === shadowID.email) {
                if (!statusKey) {
                    return {
                        status: '',
                        identity: true,
                        authenticated: true,
                        statusExists: false,
                        resetSession: false,
                    };
                }

                const decodedStatus = jwtDecode(statusKey);
                const accountStatus = decodedStatus.identity

                return {
                    identity: true,
                    statusExists: true,
                    authenticated: true,
                    resetSession: false,
                    status: accountStatus.status.toUpperCase(),
                }
            }

            return {
                status: '',
                identity: false,
                resetSession: true,
                statusExists: false,
                authenticated: false,
            };
        } catch (error) {
            return {
                status: '',
                identity: false,
                resetSession: true,
                statusExists: false,
                authenticated: false,
            };
        }

    }
}

const authenticatorInstance = new Authenticator()
export default authenticatorInstance